<template>
  <el-container class="main-container">
    <el-aside width="200px" class="main-aside">
      <!-- 菜单 -->
      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        @select="handleSelect" router>
        <el-menu-item index="home" :route="{ name: 'home' }">
          <img src="../assets/img/menu-home.png" alt="" class="menu-icon">
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="product" :route="{ name: 'product' }">
          <img src="../assets/img/menu-product.png" alt="" class="menu-icon">
          <span slot="title">产品管理</span>
        </el-menu-item>
        <el-submenu index="material" :route="{ name: 'material' }">
          <template slot="title">
            <img src="../assets/img/menu-material.png" alt="" class="menu-icon">
            <span>素材管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="material/photo" :route="{ name: 'material/photo' }">相册管理</el-menu-item>
            <!-- <el-menu-item index="material/subtitle" :route="{ name: 'material/subtitle' }">字幕管理</el-menu-item> -->
            <el-menu-item index="material/bgmusic" :route="{ name: 'material/bgmusic' }">背景音乐</el-menu-item>
            <el-menu-item index="material/subtitlemusic" :route="{ name: 'material/dubbing' }">字幕配音</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="task" :route="{ name: 'task' }">
          <img src="../assets/img/menu-task.png" alt="" class="menu-icon">
          <span slot="title">任务管理</span>
        </el-menu-item>
        <el-menu-item index="video" :route="{ name: 'video' }">
          <img src="../assets/img/menu-video.png" alt="" class="menu-icon">
          <span slot="title">视频管理</span>
        </el-menu-item>
        <el-menu-item @click="urlopen('/clip/list')">
          <img src="../assets/img/menu-video.png" alt="" class="menu-icon">
          <span slot="title">快剪列表</span>
        </el-menu-item>
      </el-menu>
      <div class="menu-bg">
        <img src="../assets/img/menu-bg.png" alt="">
      </div>
    </el-aside>
    <!-- 主要内容 -->
    <el-main class="main-content">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: 'mainPage',
  components: {

  },
  data() {
    return {
      isMeta: '',
      activeIndex: '1',
    }
  },

  methods: {
    handleOpen() {

    },
    handleClose() {

    },
    handleSelect(keyPath) {
      sessionStorage.setItem('keyPath', keyPath);
    },
    //跳转
    urlopen(router, params) {
      var res = this.$router.resolve({
        path: router,
        query: params
      });
      window.open(res.href, '_blank');
    },
  },

  mounted() {
    this.activeIndex = sessionStorage.getItem('keyPath') || '1';
  }

}

</script>


<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main-aside {
  overflow: initial;
  height: 100%;
  background-color: #0d1f75;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 0 10px;
  border: none;
  padding-top: 4.23%;
  position: relative;
  min-height: 600px;
}

.menu-bg {
  width: 200px;
  position: absolute;
  bottom: 12%;
  left: 0;
}

.menu-bg img {
  width: 100%;
}

.main-container {
  height: 100%;

}

.el-menu-vertical-demo {
  background-color: #0d1f75;
}

.el-menu-vertical-demo>>>.el-submenu__title {
  color: #fff;
}

.el-menu-item-group {
  background-color: #0d1f75;
}

.el-menu-vertical-demo {
  border: none;
}

.el-menu-vertical-demo .el-menu-item {
  color: #fff;
  border-radius: 3px;
  position: relative;
}

.el-menu-vertical-demo>>>.el-submenu__title:hover {
  background-color: #006cff;
}

.el-menu-vertical-demo .el-menu-item:hover {
  background-color: #006cff;
}

.el-menu-vertical-demo .is-active {
  background-color: #1b3194;
  position: relative;
}

.el-menu-vertical-demo .is-active::before {
  content: '';
  width: 3px;
  height: 16px;
  display: block;
  position: absolute;
  background-color: #009aff;
  border-radius: 0px 2px 2px 0px;
  left: 0;
  top: 14px;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  min-width: 180px;
}

.el-menu-vertical-demo .el-menu-item-group ul .is-active {
  background-color: #006cff;
  color: #fff;
  position: static;
}

.el-menu-vertical-demo .el-menu-item-group ul .is-active::before {
  display: none;
}

.el-menu-item-group ul .el-menu-item {
  color: #C1C8D1;
  margin: 2px 0;
}

.main-content {
  padding: 0 18px;
}

.user-content-box {
  width: 100%;
}

.el-menu-item-group>>>ul {
  box-sizing: border-box;
  padding: 4px 0px;
}

.menu-icon {
  margin-right: 14px;
}

.main-container>>>.el-menu-item {
  background-color: #0d1f75;
}

.main-container>>>.el-menu-item.is-active {
  background-color: #1b3194;
}

@media screen and (max-width:1024px) {
  .main-aside {
    padding-top: 2.23%;
  }

  .menu-bg {
    bottom: 2%;
  }
}

@media screen and (max-width:1250px) {
  .menu-bg {
    bottom: 2%;
  }

  .main-aside {
    padding-top: 2.23%;
  }
}

/* 新增 */
.main-content {
  min-width: 1000px;
}

.main-content::-webkit-scrollbar {
  display: none;
}

@media screen and (max-width:1250px) {
  .main-content {
    height: 100%;
  }
}
</style>